<main>
    <app-header id="header" />
    <app-about-me id="about-me" />
    <app-my-skills id="my-skills" />
    <app-portfolio id="portfolio" />
    <app-contact id="contact" />
</main>